<template lang="pug">
section.section-content.section-content--usage-app
    .box.box--collapse(v-bind:class="{'is-show' : showInfo}")
        .box__header.no-border
            header.flex.flex-col.items-start.justify-between(
                class="lg:flex-row lg:items-center"
            )
                .header-meta.mb-4(
                    class="lg:mb-0"
                )
                    h2.subheading Applications Usage
                .header-cta
                    .flex
                        .flex.flex-wrap(style="width:350px")
                            .block(class="w-1/2")
                                .field.mr-2
                                    .relative
                                        select.field-style(@change="sizeAppsChange($event)")
                                            option(v-for="(size, index) in optSizeApps" :key="index" :value="size.value") {{ size.text }}
                                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                            .block(class="w-1/2")
                                .field
                                    .relative
                                        select.field-style
                                            option(v-for="(by, index) in optByApps" :key="index" :value="by.value") {{ by.text }}
                                        .pointer-events-none.absolute.inset-y-0.right-0.flex.items-center.px-2
                                            <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        button.toggle-collapse.ml-4(
                            v-on:click="showInfo = !showInfo"
                        )
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-chevron-down"><polyline points="6 9 12 15 18 9"></polyline></svg>
        .box__body.mb-4
            .box-apps-usage.flex.flex-wrap
                template(v-if="load_data_status_overall_app_usage.status === 'loading'")
                    Loading(show="true")

                template(v-else)

                    template(v-if="overall_app_usage.app_usage && Object.keys(overall_app_usage.app_usage).length > 0 && Object.keys(overall_app_usage.app_usage).length >= sizeApps")
                        .list-app-usage(v-for="(n, index) in sizeApps" :key="index" class="w-1/2 lg:w-1/6")
                            .card-app-usage.flex.items-center.w-full.p-4
                                .card-app-usage__image.mr-2
                                    img.w-12.h-12.p-1.object-cover.border.rounded(v-bind:src="overall_app_usage.app_usage[index][3]" @error="getDefaultImage" alt="")
                                .card-app-usage__content.flex.flex-col
                                    span.text-overflow {{ overall_app_usage.app_usage[index][0] }}
                                    strong.monospace.text-red-500 {{ overall_app_usage.app_usage[index][2] }}

                    NoDataAvailable(v-else)

</template>

<script>
import { mapState } from 'vuex';
import Loading from '@/components/Loading.vue';
import NoDataAvailable from '@/components/NoDataAvailable.vue';

export default {
    name: 'OverallUsageApp',
    components: {
        Loading,
        NoDataAvailable,
    },
    data: function() {
        return {
            defaultImage: this.$store.getters.getDefaultImage,
            sizeApps: 20,
            showInfo: true,
            optSizeApps: [
                {
                    value:20,
                    text:'20 Aplikasi',
                },
                {
                    value:40,
                    text:'40 Aplikasi',
                },
                {
                    value:60,
                    text:'60 Aplikasi',
                },
                {
                    value:80,
                    text:'80 Aplikasi',
                },
                {
                    value:100,
                    text:'100 Aplikasi',
                },
                {
                    value:'all',
                    text:'Semua Aplikasi',
                },
            ],
            optByApps: [
                {
                    value:'size',
                    text:'Besaran Size',
                }
            ],
        }
    },
    computed: {
        ...mapState([
            'load_data_status_overall_app_usage',
            'overall_app_usage',
        ]),
    },
    methods: {
        getDefaultImage(e) {
            e.target.src = this.defaultImage;
        },
        sizeAppsChange(e) {
            var appUsage = this.overall_app_usage.app_usage
            var totalApps = appUsage.length;
            // console.log(totalApps)
            // console.log(e.target.value)
            // console.log(e.target.value == 'all')
            if (e.target.value == 'all' || totalApps < this.sizeApps) {
                this.sizeApps = parseInt(totalApps);
            } else {
                this.sizeApps = parseInt(e.target.value);
            }
        },
    },
    mounted() {
        if (this.overall_app_usage.app_usage && Object.keys(this.overall_app_usage.app_usage).length > 0) {
            var totalApps = Object.keys(this.overall_app_usage.app_usage).length;
            if (totalApps < this.sizeApps) {
                this.sizeApps = parseInt(totalApps);
            } else {
                this.sizeApps = 20;
            }
        }
        // console.log('mounted in overall - app usage : ')
        // console.log(this.overall_app_usage.app_usage);
        // console.log(Object.keys(this.overall_app_usage.app_usage).length);
        // console.log(count(this.overall_app_usage.app_usage));
    },
    watch: {
        overall_app_usage() {
            if (this.overall_app_usage.app_usage && Object.keys(this.overall_app_usage.app_usage).length > 0) {
                var totalApps = Object.keys(this.overall_app_usage.app_usage).length;
                if (totalApps < this.sizeApps) {
                    this.sizeApps = parseInt(totalApps);
                } else {
                    this.sizeApps = 20;
                }
            }
        }
    }
}
</script>

<style lang="sass" scoped>
.box--collapse
    .box__body
        display: none
    &.is-show
        .toggle-collapse
            transform: rotate(180deg)
        .box__body
            display: block

.text-overflow
    max-width: 100px
    text-overflow: ellipsis
    white-space: nowrap
    overflow: hidden
    font-size: 13px

</style>
